<template>

  <div class="header" v-if="systemConfig.indexStyle == 1 || systemConfig.indexStyle == 2  || systemConfig.indexStyle == 3"
       :style="{'backgroundColor':headerBackgroundColor ? headerBackgroundColor :'#fff'}">
    <div class="header-box">
      <router-link class="logo" target="_blank" to="/NotariaIndex">
        <img :src="systemConfig.logoLightUrl" alt="公证系统">
      </router-link>
      <div class="nav-box">
        <el-menu
          :default-active="activeTab"
          :text-color="defaultTextColor?defaultTextColor:'#000'"
          active-text-color="#ffffff"
          mode="horizontal"
          :background-color="menuBackgroundColor ? menuBackgroundColor : '#fff'"
          @select="selectMenu"
        >
          <el-menu-item v-for="item in titleList" :key="item.path" :index="item.path" @click="toSkip(item)"
                        :class="{'is-active':+activeTab===+item.index}">
            <span class="txtTitle" slot="title">{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
    <div class="user-info">
      <div v-if="showInfo">
        <span style="margin-right: 10px">{{ userName }}</span>
        <span class="loginout" @click="loginOut">退出</span>
      </div>
      <div v-else class="login">
        <el-button v-if="showLoginBtn" :class="btnColor? 'card-btn2': 'card-btn'" type="text" @click="loginIn">
          申请人登录
        </el-button>
        <el-button :class="btnColor? 'card-btn2': 'card-btn'" type="text" @click="notariaLogin">
          公证员入口
        </el-button>
      </div>

    </div>

    <div v-show="modelShow"
         style="width: 100%;height: 100%;background: rgba(0,0,0,0.4);z-index: 2000;display: flex;justify-content: center;align-items: center;position: fixed;top: 0;left: 0">
      <div style="width: 480px;height: 300px;border-radius: 10px;background: #ffffff">
        <el-row
          style="border-bottom: 1px solid #EEEEEE;height: 50px;font-size: 16px;font-weight: 600;color: rgba(0,0,0,0.85);line-height: 50px;padding-left: 20px">
          友情提示
        </el-row>
        <el-row style="height: 190px;position: relative">
          <img src="../../static/img/construction.png"
               style="width: 233px;height: 131px;position: absolute;top: 34px;left: 52px;">
          <p
            style="display: block;position: absolute;top: 90px;left: 266px;font-size: 14px;line-height: 20px;color: rgba(0,0,0,0.85);font-weight: 500;width: 26%">
            建设中，尽请期待...</p>
        </el-row>
        <el-row style="height: 60px;position: relative">
          <el-button type="text" class="cancelBox" @click="cancelModel">取消</el-button>
          <el-button class="confirmBox" @click="cancelModel">确定</el-button>
        </el-row>
      </div>
    </div>
  </div>
  <div class="header2" v-else-if="systemConfig.indexStyle == 4">
    <div class="header-top">
      <p class="title">您好，欢迎来到{{systemConfig.notaryName}}公证处电子数据存证公证系统！</p>
      <div class="right">
        <p @click="notariaLogin" class="into"><span>公证员入口</span></p>
        <div style="display: flex;align-items: center">
          <p style="padding-top: 4px">
            <img src="../../static/img/notariaIndex/white-phone.png"/>
          </p>
          <p>{{systemConfig.notaryPhone}}</p>
        </div>
      </div>
    </div>
    <div class="header-box">
      <router-link class="logo" target="_blank" to="/NotariaIndex">
        <img :src="systemConfig.logoLightUrl" alt="公证系统">
      </router-link>
      <div class="nav-box">
        <el-menu
          :default-active="activeTab"
          :text-color="defaultTextColor?defaultTextColor:'#000'"
          active-text-color="#ffffff"
          mode="horizontal"
          :background-color="menuBackgroundColor ? menuBackgroundColor : '#fff'"
          @select="selectMenu"
        >
          <el-menu-item v-for="item in titleList" :key="item.path" :index="item.path" @click="toSkip(item)"
                        :class="{'is-active':+activeTab===+item.index}">
            <span class="txtTitle" slot="title">{{ item.title }}</span>
          </el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
  import httpServer from '../http/http-server'
  import config from "../config";
  import {mapMutations, mapState} from 'vuex';

  export default {
    name: 'IndexHeader',
    props: {
      headerBackgroundColor: {
        type: String
      },
      menuBackgroundColor: {
        type: String
      },
      defaultTextColor: {
        type: String
      },
      txtTitle: {
        type: String
      },
      btnColor: {
        type: String,
        default: ''
      }

    },

    data() {
      return {
        modelShow: false,
        showInfo: false,
        showLoginBtn:true,
        titleList: [
          {title: '首页', path: '/NotariaIndex', name: 'NotariaIndex', tabIndex: 0, index: 1},
          {title: '区块链查询', path: '/chain', name: 'chain', tabIndex: 1, index: 2},
          {title: '办证指南', path: '/TransactGuide', name: 'TransactGuide', tabIndex: 2, index: 3},
          {title: '申办须知', path: '/BidNotice', name: 'BidNotice', tabIndex: 3, index: 4},
          // {title: '公证预约', path: '/Appointment', name: 'Appointment',tabIndex: 4,index:5},//弃用
          {title: '公证预约', path: '/NotarAppointment', name: 'NotarAppointment',tabIndex: 4,index:5},
          {title: '证书验证', path: '/Verification', name: 'Verification', tabIndex: 5, index: 6},
          {title: '关于我们', path: '/AboutUs', name: 'AboutUs', tabIndex: 6, index: 7}
        ],
        activeTab: '1',
        systemConfig: {},
      }
    },
    created() {
      // this.activeTab = `${this.$route.query.index}`;
      this.activeTab = `${this.$route.query.index || '1'}`
      this.systemConfig = this.$store.getters.systemConfig
      if(config&&config.domain&& config.domain.hiddenLoginBtn){
        this.showLoginBtn = !config.domain.hiddenLoginBtn
      }
      // console.log( this.systemConfig.logoLightUrl,' this.systemConfig.logoLightUrl')
      // httpServer.profile({home: true}).then((res) => {
      //   if (!res.success) {
      //     // this.$message({
      //     //   message: res.message,
      //     //   type: 'warning'
      //     // })
      //     this.showInfo = false
      //   } else {
      //     this.userName = res.data.entityName
      //     this.showInfo = true
      //   }
      // }).catch((err) => {
      //   console.log(err)
      // })
    },

    computed: {
      isActive() {
        return this.titleList.map(i => {
          i.index === +this.activeTab
        })
      }
    },
    watch: {
      '$store.getters.systemConfig': {
        handler(newValue) {
          if (newValue) {
            this.systemConfig = this.$store.getters.systemConfig
          }

        },
        deep: true
      }
    },
    methods: {
      ...mapMutations(['SET_Type']),
      loginIn() {
        localStorage.removeItem(this.globalConfig.TOKEN_KEY)
        //为需要显示功能之和；1:一般公证 2:赋强公证 4:公证电子签 8:存证公证 16:存证保管函 32:公证取证
        if (this.globalConfig.domain.menus) {
          if ((this.globalConfig.domain.menus & 1) == 1) {
            this.SET_Type('zz')
          } else if ((this.globalConfig.domain.menus & 2) == 2) {
            this.SET_Type('fq')
          } else if ((this.globalConfig.domain.menus & 8) == 8 || (this.globalConfig.domain.menus & 16) == 16) {
            this.SET_Type('cz')
          } else if ((this.globalConfig.domain.menus & 4) == 4) {
            this.SET_Type('dzq')
          }
        } else {
          this.SET_Type('zz')
        }
        this.$router.push('/login')
      },
      notariaLogin() {
        location.href = config.domain.baseURL.replace('web', 'boss')
      },
      loginOut() {
        httpServer.logout({}).then(res => {
          if (res.success) {
            localStorage.removeItem(this.globalConfig.TOKEN_KEY)
            this.userName = ''
            this.showInfo = false
            // this.$router.push('/NotariaIndex')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      toSkip(num) {
        this.activeTab = `${num.index}`
        this.$router.push({path: num.path, query: {index: num.index}})
      },
      open() {
        this.modelShow = true;
      },
      cancelModel() {
        this.modelShow = false
      },
      selectMenu(index) {
        console.log(index, 'index')

      }
    }
  };
</script>

<style scoped lang="less">
@media (max-width: 1480px){
  .header{
    zoom: 0.9;
  }
}
@media (max-width: 1280px){
  .header{
    zoom: 0.8;
  }
}
  .header {
    height: 100px;
    width: 100%;
    display: flex;

    .user-info {
      width: 200px;
      margin-left: 20px;
      right: 0;
      top: 0;
      font-size: 14px;
      justify-self: right;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .loginout, .login {
        cursor: pointer;
        display: flex;
        margin-right: 20px;

        .card-btn {
          color:  rgba(44, 105, 236, 1);
          border: 1px solid  rgba(44, 105, 236, 1);
          padding: 10px;
          border-radius: 8px;

          &:hover {
            background:  rgba(44, 105, 236, 1);
            color: #fff;
          }
        }

        .card-btn2 {
          /*color: #E23F3F;*/
          /*border: 1px solid #E23F3F;*/
          color: #fff;
          background:  rgba(44, 105, 236, 1);
          padding: 10px;
          border-radius: 8px;

          &:hover {
            background: rgba(44, 105, 236, 1);
          }
        }
      }
    }

    .header-box {
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      width: 75%;
      /*min-width: 1050px;*/
      //min-width: 1200px;

      .logo {
        margin: auto 0;
        //@media (max-width: 1280px){
        //  img {
        //    max-width: 200px!important;
        //  }
        //}
        img {
          max-width: 250px;
        }
      }

      .nav-box {
        height: 100%;
        width: 75%;

        /deep/ .el-menu {
          height: 100%;
          border-bottom: 0;
          /*min-width: 850px;*/

          @media screen and (max-width: 1280px) {
            .el-menu-item {
              width: 80px;
            }
          }
          @media screen and (max-width: 1400px) {
            .el-menu-item {
              width: 100px;
            }
          }


          .el-menu-item {
            height: 100%;
            line-height: 100px;
            border-bottom: 0px !important;

            &:hover {
              background: unset !important;
            }

            .txtTitle {
              border-radius: 28px;
              display: inline-block;
              width: 80px;
              min-height: 24px;
              text-align: center;
              line-height: 24px;

              &:hover {
                background:  rgba(44, 105, 236, 1);
                color: #fff;
              }
            }

            &.is-active .txtTitle {
              background:  rgba(44, 105, 236, 1);
              color: #fff;
            }

          }

        }
      }
    }
  }

  .header2 {
    width: 100%;

    .header-top {
      background: #1C63CE;
      height: 40px;
      width: 100%;
      display: flex;
      color: #fff;
      font-size: 14px;
      position: relative;
      line-height: 40px;

      .title {
        margin-left: 10%;
      }

      .right {
        position: absolute;
        right: 10%;
        display: flex;

        img {
          margin-top: 2px;
        }

        .into {
          cursor: pointer;
          margin-right: 48px;

          span {
            border-bottom: 1px solid #fff;
          }

        }
      }
    }

    .header-box {
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      width: 75%;
      /*min-width: 1050px;*/
      //min-width: 1200px;

      .logo {
        margin: auto 0;
        //@media (max-width: 1280px){
        //  img {
        //    max-width: 200px!important;
        //  }
        //}
        img {
          max-width: 250px;
        }
      }

      .nav-box {
        height: 100%;
        width: 75%;

        /deep/ .el-menu {
          height: 100%;
          border-bottom: 0;
          /*min-width: 850px;*/

          @media screen and (max-width: 1280px) {
            .el-menu-item {
              width: 80px;
            }
          }
          @media screen and (max-width: 1400px) {
            .el-menu-item {
              width: 100px;
            }
          }


          .el-menu-item {
            height: 100%;
            line-height: 100px;
            border-bottom: 0px !important;

            &:hover {
              background: unset !important;
            }

            .txtTitle {
              border-radius: 28px;
              display: inline-block;
              width: 80px;
              min-height: 24px;
              text-align: center;
              line-height: 24px;
              height: 30px;


              &:hover {
                color: #000;
                border-bottom: 2px solid #149CEB;
                border-radius: 0;
              }
            }

            &.is-active .txtTitle {
              /*background: #d0021b;*/
              color: #000;
              border-bottom: 2px solid #149CEB;
              border-radius: 0;

            }

          }

        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/IndexHeader.vue